export default __webpack_public_path__ + "static/media/fixtures.a4816d87.png";